(function(){
  if(window.__irxReveal)return; window.__irxReveal=1;
  function init(){
    var els=document.querySelectorAll('.irx-reveal');
    if(!('IntersectionObserver' in window)||!window.matchMedia||!window.matchMedia('(prefers-reduced-motion: no-preference)').matches){
      els.forEach(function(el){el.classList.add('is-in');});
      return;
    }
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); } });
    },{rootMargin:'0px 0px -8% 0px',threshold:0.06});
    els.forEach(function(el){ io.observe(el); });
  }
  if(document.readyState!=='loading'){ init(); } else { document.addEventListener('DOMContentLoaded', init); }
})();
